import { graphql } from "../generated";

export const ADMIN_USER = graphql(`
  query GetAdminUser($name: String!) {
    adminUser(name: $name) {
      id
      ip
      verified
      banned
      postBannedUntil
      relatedUsersByClientId {
        id
        name
        banned
        verified
        dateJoined
        theme {
          post
          username
        }
        avatarUrl
      }
      relatedUsersByIp {
        id
        name
        banned
        verified
        dateJoined
        theme {
          post
          username
        }
        avatarUrl
      }
    }
  }
`);
